import { render } from "./PrivacyPolicyMfg.vue?vue&type=template&id=1d2e786e&scoped=true"
import script from "./PrivacyPolicyMfg.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyMfg.vue?vue&type=script&lang=js"

import "./PrivacyPolicyMfg.vue?vue&type=style&index=0&id=1d2e786e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2e786e"]])

export default __exports__